///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { GtthSharedModule } from '../shared/shared.module';
import { accountState } from './account.route';
import { PasswordComponent } from './password/password.component';
import { SettingsComponent } from './settings/settings.component';
import { PasswordResetFinishComponent } from './password-reset/finish/password-reset-finish.component';
import { PasswordResetInitComponent } from './password-reset/init/password-reset-init.component';
import { PasswordResetFinishService } from './password-reset/finish/password-reset-finish.service';
import { PasswordResetInitService } from './password-reset/init/password-reset-init.service';
import { Password } from './password/password.service';
import { SuiLoadingDirective, SuiPasswordControlComponent, SuiStringControlComponent, SuiTranslatePipe } from '@siklu/sui-lib';

@NgModule({
    imports: [
        GtthSharedModule,
        RouterModule.forChild(accountState),
        SuiTranslatePipe,
        SuiStringControlComponent,
        SuiLoadingDirective,
        SuiPasswordControlComponent
    ],
    declarations: [PasswordComponent, SettingsComponent, PasswordResetFinishComponent, PasswordResetInitComponent],
    providers: [Password, PasswordResetFinishService, PasswordResetInitService]
})
export class GtthAccountModule {}
